export default "__VITE_ASSET__bef1fc4e__"